import React, { useEffect, useState } from "react";
import Snacky from "../../Shared/Snacky";
import axios from "axios";
import { Skeleton } from "@material-ui/lab";
import ProductCategoriesTable from "./ProductCategoriesTable";
import { Button, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { setSnackBarProps } from "../../../reduxActions/snackbar";

const ProductCategories = ({ snackbar, setSnackBarProps }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [productCategories, setProductCategories] = useState([]);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [updatedCategories, setUpdatedCategories] = useState([]);

  useEffect(() => {
    getAllProductCategories();
  }, []);

  const getAllProductCategories = () => {
    setIsLoading(true);
    axios
      .get(`products/GetProductCategories`)
      .then(({ data }) => {
        setProductCategories(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreateBlankCategory = () => {
    const _newCategory = {
      name: "",
      color: "#aabbcc",
    };
    setProductCategories([_newCategory, ...productCategories]);
    setIsAddingNew(true);
    setHasChanges(true);
  };

  const batchUpdateProductCategoriesState = (savedCategories) => {
    let productCategoriesClone = [...productCategories];
    savedCategories.forEach((productCategory) => {
      productCategoriesClone = productCategoriesClone.map((pc) =>
        pc.id === productCategory.id || !pc.id ? productCategory : pc
      ); // in case pc.id is undefined it replaces with the first category from savedCategories list. Api returns the new product first.
    });
    setProductCategories(productCategoriesClone);
  };

  const handleSaveCategory = () => {
    if (updatedCategories.length > 0) {
      setIsSaving(true);
      axios
        .post(`Products/BatchSaveProductCategories`, updatedCategories)
        .then(({ data }) => {
          setIsAddingNew(false);
          setHasChanges(false);
          batchUpdateProductCategoriesState(data);
          setUpdatedCategories([]);
          setSnackBarProps(
            "success",
            `Fantastic! The categories have been saved.`,
            true
          );
        })
        .catch((err) => {
          console.log(err);
          setSnackBarProps("warning", `Oops! Unable to save categories.`, true);
        })
        .finally(() => {
          setIsSaving(false);
        });
    }
  };

  const handleUpdateProductCategoryChangeList = (productCategory) => {
    const existingProductCategory = updatedCategories.find(
      (p) => p.id === productCategory.id
    );
    if (existingProductCategory) {
      setUpdatedCategories(
        updatedCategories.map((p) =>
          p.id === productCategory.id ? productCategory : p
        )
      );
    } else {
      setUpdatedCategories([...updatedCategories, productCategory]);
    }
    setHasChanges(true);
  };

  const handleConfirmCategoryDeletion = (categoryId) => {
    if (categoryId) {
      axios
        .delete(`products/DeleteProductCategory/${categoryId}`)
        .then(() => {
          setProductCategories(
            productCategories.filter((pc) => pc.id !== categoryId)
          );
          setSnackBarProps(
            "success",
            `Done! The category has been deleted.`,
            true
          );
        })
        .catch((err) => {
          console.log(err);
          setSnackBarProps("warning", `Oops! Unable to category box.`, true);
        });
    }
  };

  return (
    <div>
      <Snacky snackprops={snackbar} setSnackBarProps={setSnackBarProps} />
      <div className="products-root">
        {isLoading ? (
          <div className="products-loading-skeleton-container">
            <Skeleton height={50} />
            <Skeleton height={50} />
            <Skeleton height={50} />
          </div>
        ) : (
          <div className="product-results-container">
            <div className="products-actions-container">
              {!isAddingNew && !isSaving && (
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={(e) => {
                    handleCreateBlankCategory();
                  }}
                >
                  Add new category
                </Button>
              )}
              {!isSaving && hasChanges && (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={(e) => {
                    handleSaveCategory();
                  }}
                >
                  Save
                </Button>
              )}
            </div>
            {productCategories.length > 0 ? (
              <ProductCategoriesTable
                productCategories={productCategories}
                handleConfirmCategoryDeletion={handleConfirmCategoryDeletion}
                handleUpdateProductCategoryChangeList={
                  handleUpdateProductCategoryChangeList
                }
              />
            ) : (
              <div
                className="producs-paper-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 30,
                }}
              >
                <Typography>
                  <strong>No Categories Found</strong>
                </Typography>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  snackbar: state.snackbar,
});

export default connect(mapStateToProps, {
  setSnackBarProps,
})(ProductCategories);
